export default {
    LOAD_PROVIDER(state, provider) {
        state.items = provider;
    }
}
